import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications(state, action) {
      state.items = Array.isArray(action.payload) ? action.payload : [];
      state.loading = false;
      state.error = null;
    },
    appendNotification(state, action) {
      state.items.unshift(action.payload);
    },
    markAsRead(state, action) {
      const notification = state.items.find((n) => n.id === action.payload);
      if (notification) {
        notification.isRead = true;
      }
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearNotifications(state) {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setNotifications,
  appendNotification,
  markAsRead,
  setLoading,
  setError,
  clearNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
